import {language} from "../../language/Language"; // تأكد من أنك تستورد المتغير language
import {Helmet} from "react-helmet";

const Contact = () => {
    return (
        <div
            className={`container mb-10 mt-32 grid md:grid-cols-2 gap-16 items-center relative overflow-hidden p-8 shadow-[0_2px_10px_-3px_rgba(6,81,237,0.3)] rounded-3xl bg-white font-[sans-serif] before:absolute
        ${
            language === "ar" ? "before:left-0" : "before:right-0"
        }  before:w-[300px] before:bg-blue-400 before:h-full max-md:before:hidden`}
        >
            <Helmet>
                <title>Meat-House El-Fardos</title>
                <meta
                    name="description"
                    content="لأي استفسار أو طلب خاص بمنتجات اللحوم أو التوصيل، تواصل مع فريق Meat House عبر الهاتف أو البريد الإلكتروني. خدمة عملاء سريعة ودعم متواصل."
                />
                {/* Structured Data for ContactPage */}
                <script type="application/ld+json">
                    {`
            {
              "@context": "https://schema.org",
              "@type": "ContactPage",
              "name": "تواصل معنا | Meat House",
              "description": "تواصل مع فريق Meat House لأي استفسار أو دعم.",
              "url": "https://meat-house.online/contact"
            }
          `}
                </script>
            </Helmet>
            <div>
                <h2 className="text-gray-800 text-3xl font-extrabold">
                    {language === "ar" ? "تواصل معنا" : "Get In Touch"}
                </h2>
                <p className="text-sm text-gray-500 mt-4 leading-relaxed">
                    {language === "ar"
                        ? "هل لديك استفسار محدد أو تبحث عن فرص جديدة؟ فريقنا ذو الخبرة جاهز للتفاعل معك."
                        : "Have a specific inquiry or looking to explore new opportunities? Our experienced team is ready to engage with you."}
                </p>

                <form>
                    <div className="space-y-4 mt-8">
                        <input
                            type="text"
                            placeholder={language === "ar" ? "الاسم الكامل" : "Full Name"}
                            className="px-2 py-3 bg-white w-full text-gray-800 text-sm border-b border-gray-300 focus:border-blue-600 outline-none"
                        />
                        <input
                            type="text"
                            placeholder={language === "ar" ? "الشارع" : "Street"}
                            className="px-2 py-3 bg-white w-full text-gray-800 text-sm border-b border-gray-300 focus:border-blue-600 outline-none"
                        />
                        <div className="grid grid-cols-2 gap-6">
                            <input
                                type="text"
                                placeholder={language === "ar" ? "المدينة" : "City"}
                                className="px-2 py-3 bg-white w-full text-gray-800 text-sm border-b border-gray-300 focus:border-blue-600 outline-none"
                            />
                            <input
                                type="text"
                                placeholder={language === "ar" ? "الرمز البريدي" : "Postcode"}
                                className="px-2 py-3 bg-white w-full text-gray-800 text-sm border-b border-gray-300 focus:border-blue-600 outline-none"
                            />
                        </div>
                        <input
                            type="number"
                            placeholder={language === "ar" ? "رقم الهاتف" : "Phone No."}
                            className="px-2 py-3 bg-white w-full text-gray-800 text-sm border-b border-gray-300 focus:border-blue-600 outline-none"
                        />
                        <input
                            type="email"
                            placeholder={language === "ar" ? "البريد الإلكتروني" : "Email"}
                            className="px-2 py-3 bg-white w-full text-gray-800 text-sm border-b border-gray-300 focus:border-blue-600 outline-none"
                        />
                        <textarea
                            placeholder={language === "ar" ? "اكتب رسالتك" : "Write Message"}
                            className="px-2 pt-3 bg-white w-full text-gray-800 text-sm border-b border-gray-300 focus:border-blue-600 outline-none"
                        />
                    </div>

                    <button
                        type="button"
                        className="mt-8 flex items-center justify-center text-sm w-full rounded-md px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16px"
                            height="16px"
                            fill="#fff"
                            className="mr-2"
                            viewBox="0 0 548.244 548.244"
                        >
                            <path
                                fillRule="evenodd"
                                d="M392.19 156.054 211.268 281.667 22.032 218.58C8.823 214.168-.076 201.775 0 187.852c.077-13.923 9.078-26.24 22.338-30.498L506.15 1.549c11.5-3.697 24.123-.663 32.666 7.88 8.542 8.543 11.577 21.165 7.879 32.666L390.89 525.906c-4.258 13.26-16.575 22.261-30.498 22.338-13.923.076-26.316-8.823-30.728-22.032l-63.393-190.153z"
                                clipRule="evenodd"
                            />
                        </svg>
                        {language === "ar" ? "إرسال الرسالة" : "Send Message"}
                    </button>
                </form>

                <ul className="mt-4 flex flex-wrap justify-center gap-6">
                    <li className="flex items-center text-blue-600">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16px"
                            height="16px"
                            fill="currentColor"
                            viewBox="0 0 479.058 479.058"
                        >
                            <path d="M434.146 59.882H44.912C20.146 59.882 0 80.028 0 104.794v269.47c0 24.766 20.146 44.912 44.912 44.912h389.234c24.766 0 44.912-20.146 44.912-44.912v-269.47c0-24.766-20.146-44.912-44.912-44.912zm0 29.941c2.034 0 3.969.422 5.738 1.159L239.529 264.631 39.173 90.982a14.902 14.902 0 0 1 5.738-1.159zm0 299.411H44.912c-8.26 0-14.971-6.71-14.971-14.971V122.615l199.778 173.141c2.822 2.441 6.316 3.655 9.81 3.655s6.988-1.213 9.81-3.655l199.778-173.141v251.649c-.001 8.26-6.711 14.97-14.971 14.97z" />
                        </svg>
                        <a href="mailto:zezofix@gmail.com" className="text-sm ml-4">
                            <strong>zezofix@gmail.com</strong>
                        </a>
                    </li>
                    <li className="flex items-center text-blue-600">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16px"
                            height="16px"
                            fill="currentColor"
                            viewBox="0 0 482.6 482.6"
                        >
                            <path d="M98.339 320.8c47.6 56.9 104.9 101.7 170.3 133.4 24.9 11.8 58.2 25.8 95.3 28.2 2.3.1 4.5.2 6.8.2 24.9 0 44.9-8.6 61.2-26.3.1-.1.3-.3.4-.5 5.8-7 12.4-13.3 19.3-20 4.7-4.5 9.5-9.2 14.1-14 21.3-22.2 21.3-50.4-.2-71.9l-60.1-60.1c-10.2-10.6-22.4-16.2-35.2-16.2-12.8 0-25.1 5.6-35.6 16.1l-35.8 35.8c-3.3-1.9-6.7-3.6-9.9-5.2-4-2-7.7-3.9-11-6-32.6-20.7-62.2-47.7-90.5-82.4-14.3-18.1-23.9-33.3-30.6-48.8 9.4-8.5 18.2-17.4 26.7-26.1 3-3.1 6.1-6.2 9.2-9.3 10.8-10.8 16.6-23.3 16.6-36s-5.7-25.2-16.6-36l-29.8-29.8c-3.5-3.5-6.8-6.9-10.2-10.4-6.6-6.8-13.5-13.8-20.3-20.1-10.3-10.1-22.4-15.4-35.2-15.4-12.7 0-24.9 5.3-35.6 15.5l-37.4 37.4c-13.6 13.6-21.3 30.1-22.9 49.2-1.9 23.9 2.5 49.3 13.9 80 17.5 47.5 43.9 91.6 83.1 138.7zm-72.6-216.6c1.2-13.3 6.3-24.8 14.5-33.3l60.1-60.1c13.6-13.7 30.4-21.3 48.6-21.3 18.2 0 35.2 7.6 48.8 21.3l87.8 87.9c6.9 6.9 13.6 14.1 19.6 21.5 17.9 21.5 23.8 51.7 15.5 78.4-9.1 26.2-32.6 42.5-59.8 42.5-7.6 0-15.1-1.3-22.5-3.6l-79.2-79.3-78.2-78.3-65.2 65.2c-16.3-19.4-25.9-42.7-25.9-66.4-.1-12.4 3.2-25.2 9.5-37.8z" />
                        </svg>
                        <a href="tel:01143837483" className="text-sm ml-4">
                            <strong>01143837483</strong>
                        </a>
                    </li>
                </ul>
            </div>
            <div className="z-10 relative h-full max-md:min-h-[350px]">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15926.28168550672!2d31.050920429329707!3d29.955577507408886!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x145851245ce9c1c7%3A0x75f6fd915e8daff5!2zTWVhdCBIb3VzZSDZhdmK2KrZh9in2YjYsw!5e1!3m2!1sar!2seg!4v1755248890483!5m2!1sar!2seg"
                    className="left-0 top-0 h-full w-full rounded-t-lg lg:rounded-tr-none lg:rounded-bl-lg"
                    frameBorder="0"
                    allowFullScreen
                    title="Google Map"
                ></iframe>
            </div>
        </div>
    );
};

export default Contact;
